// extracted by mini-css-extract-plugin
module.exports = {"infoRow":"styles_infoRow__2n8YR","title":"styles_title__2l66h","value":"styles_value__1iOuY","autobookInfoFlexP":"styles_autobookInfoFlexP__2HAFY"};